import { combineReducers } from 'redux';
import tableViewReducer from './TableView/store/tableViewReducer';

export const reducers = combineReducers({
    tableView: tableViewReducer
});